<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" id="notification-button">
    <feather-icon v-if="status === 'None'" icon="EyeIcon" svgClasses="w-4 h-4 hover:text-secondary stroke-current"  />
    <feather-icon v-if="status === '0'" icon="AlertOctagonIcon"  class="yangin" svgClasses="w-4 h-4 hover:text-secondary stroke-current"  />
    <feather-icon v-if="status === '1'" icon="XIcon"  class="yangin-degil" svgClasses=" w-4 h-4 hover:text-secondary stroke-current" />
    <feather-icon v-if="status === '2'" icon="FlagIcon" class="yangin-kontrol" svgClasses=" w-4 h-4 hover:text-secondary stroke-current" />
    <feather-icon v-if="status === '3'" icon="HexagonIcon" class="sogutma" svgClasses="w-4 h-4 hover:text-secondary stroke-current" />
    <feather-icon v-if="status === '4'" icon="CheckIcon"  class="yangin-sondu-in" svgClasses="w-4 h-4 hover:text-secondary stroke-current" />

    <vs-dropdown-menu v-if="!isHide" class="notification-dropdown dropdown-custom vx-navbar-dropdown">
      <form data-vv-scope="profile">

      <div class="notification-top text-center p-5 bg-primary">
        <h3 class="text-white">Yeni Durum Kaydı</h3>
      </div>

      <component :is="scrollbarTag" ref="mainSidebarPs"
                 class="scroll-area--nofications-dropdown p-0 mb-10"
                 :settings="settings" :key="$vs.rtl">

        <h5 class="p-4 text-gray pb-0">Durum</h5>
        <ul class="bordered-items mt-0">
          <li class="flex justify-between px-4 py-4 notification cursor-pointer">
            <div class="w-full flex flex-col items-start flex-grow-0 flex-wrap">
              <div v-bind:key="check_item.id" v-for="(check_item) in statusList">

                <vs-radio v-model="selectedStatus" v-if="check_item.value !== 'None'" :vs-value="check_item.value" class="mr-4" vs-name="navbar-type-static">
                  <feather-icon v-if="check_item.value === '0'" icon="AlertOctagonIcon" v-tooltip="'Orman Yangını'" class="yangin" svgClasses="w-4 h-4 hover:text-secondary stroke-current"  />
                  <feather-icon v-if="check_item.value === '1'" icon="XIcon" v-tooltip="'Yangın Değil'"  class="yangin-degil" svgClasses=" w-4 h-4 hover:text-secondary stroke-current" />
                  <feather-icon v-if="check_item.value === '2'" icon="FlagIcon" v-tooltip="'Kontrol altında'" class="yangin-kontrol" svgClasses=" w-4 h-4 hover:text-secondary stroke-current" />
                  <feather-icon v-if="check_item.value === '3'" icon="HexagonIcon" v-tooltip="'Zirai Yangın'" class="sogutma" svgClasses="w-4 h-4 hover:text-secondary stroke-current" />
                  <feather-icon v-if="check_item.value === '4'" icon="CheckIcon" v-tooltip="'Söndürüldü'" class="yangin-sondu-in" svgClasses="w-4 h-4 hover:text-secondary stroke-current" />

                  {{check_item.text}}</vs-radio>
              </div>
<!--              <div class="w-full  flex-grow-1">

                <h5 class="pt-4 pb-4 text-gray pb-0 ml-0">Açıklama</h5>
                <vs-textarea class="w-full"
                             rows="3"
                             name="description"
                             data-vv-as="Açıklama"
                             v-validate="'required'"
                             v-model="description"  />
                <span v-show="errors.has('profile.description')" class="text-danger">{{ errors.first('profile.description') }}</span>

              </div>-->
            </div>
          </li>
        </ul>
      </component>

      <div @click.prevent="submitUserForm" class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        green
        w-full
        p-2
        font-semibold
        text-center
        border
        border-b-0
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        cursor-pointer">
        <span>Kaydet</span>
      </div>
      </form>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import moment from 'moment'

export default {
  components: {
    VuePerfectScrollbar
  },
  props: {
    status: {
      type: String
    },
    event: {
      type: Object
    }
  },
  mounted () {
    switch (this.status) {
    case 'None':
      this.selectedStatus = this.statusList[0].value
      break
    case '0':
      this.selectedStatus = this.statusList[1].value
      break
    case '1':
      this.selectedStatus = this.statusList[2].value
      break
    case '2':
      this.selectedStatus = this.statusList[3].value
      break
    case '3':
      this.selectedStatus = this.statusList[4].value
      break
    case '4':
      this.selectedStatus = this.statusList[5].value
      break

    }
  },
  data () {
    return {
      isHide: false,
      description: '',
      selectedStatus: 'None',
      statusList: [
        { text: 'Duman Algılandı', value: 'None'},
        { text: 'Orman Yangını', value: '0'},
        { text: 'Yangın Değil', value: '1'},
        { text: 'Kontol Altında', value: '2'},
        { text: 'Zirai Yangın', value: '3'},
        { text: 'Söndürüldü', value: '4'}
      ],
      unreadNotifications: [
        {
          index    : 0,
          title    : 'New Message',
          msg      : 'Are your going to meet me tonight?',
          icon     : 'MessageSquareIcon',
          time     : this.randomDate({sec: 10}),
          category : 'primary'
        },
        { index    : 1,
          title    : 'New Order Recieved',
          msg      : 'You got new order of goods.',
          icon     : 'PackageIcon',
          time     : this.randomDate({sec: 40}),
          category : 'success'
        },
        { index    : 2,
          title    : 'Server Limit Reached!',
          msg      : 'Server have 99% CPU usage.',
          icon     : 'AlertOctagonIcon',
          time     : this.randomDate({min: 1}),
          category : 'danger'
        },
        { index    : 3,
          title    : 'New Mail From Peter',
          msg      : 'Cake sesame snaps cupcake',
          icon     : 'MailIcon',
          time     : this.randomDate({min: 6}),
          category : 'primary'
        },
        { index    : 4,
          title    : 'Bruce\'s Party',
          msg      : 'Chocolate cake oat cake tiramisu',
          icon     : 'CalendarIcon',
          time     : this.randomDate({hr: 2}),
          category : 'warning'
        }
      ],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  computed: {
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    submitUserForm () {
      return new Promise(() => {
        this.$validator.validateAll('profile').then(result => {
          if (result) {
            this.isHide = true
            this.editEventList(this.event, this.selectedStatus)
          } else {
            this.$vs.notify({
              title: 'Hata',
              text: 'Lütfen gerekli alanları doldurun',
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })
          }
        })
      })
    },
    editEventList (event, status) {
      const id = event.id
      if (this.status !== 'None' && status === '1') {
        this.$vs.notify({
          title: 'Uyarı',
          text: 'Durum "Yangın Değil" olarak seçilemez',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning'
        })
      } else {
        this.$vs.loading()
        const payload = {
          id,
          status,
          description: moment().format('DD/MM/YYYY hh:mm')
        }

        this.$store.dispatch('editEvent', payload)
          .then((response) => {
            console.log('event edit', response)
            this.getEventList()
            this.$vs.loading.close()
          })
          .catch(error => {
            this.$vs.loading.close()
            console.log('error', error)
          })
      }
    },
    getEventList () {
      this.$vs.loading()
      const payload = {
        page: 1
      }

      this.$store.dispatch('getEvents', payload)
        .then((response) => {
          console.log('event list', response)
          this.$vs.loading.close()
        })
        .catch(error => {
          this.$vs.loading.close()
          console.log('error', error)
        })
    },
    onModifierCheckChange (check_item) {
      console.log('check_item', check_item)
    },
    elapsedTime (startTime) {
      const x        = new Date(startTime)
      const now      = new Date()
      let timeDiff = now - x
      timeDiff    /= 1000

      const seconds = Math.round(timeDiff)
      timeDiff    = Math.floor(timeDiff / 60)

      const minutes = Math.round(timeDiff % 60)
      timeDiff    = Math.floor(timeDiff / 60)

      const hours   = Math.round(timeDiff % 24)
      timeDiff    = Math.floor(timeDiff / 24)

      const days    = Math.round(timeDiff % 365)
      timeDiff    = Math.floor(timeDiff / 365)

      const years   = timeDiff

      if (years > 0) {
        return `${years + (years > 1 ? ' Years ' : ' Year ')}ago`
      } else if (days > 0) {
        return `${days + (days > 1 ? ' Days ' : ' Day ')}ago`
      } else if (hours > 0) {
        return `${hours + (hours > 1 ? ' Hrs ' : ' Hour ')}ago`
      } else if (minutes > 0) {
        return `${minutes + (minutes > 1 ? ' Mins ' : ' Min ')}ago`
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? ' sec ago' : 'just now')
      }

      return 'Just Now'
    },
    // Method for creating dummy notification time
    randomDate ({ hr, min, sec }) {
      const date = new Date()

      if (hr) date.setHours(date.getHours() - hr)
      if (min) date.setMinutes(date.getMinutes() - min)
      if (sec) date.setSeconds(date.getSeconds() - sec)

      return date
    }
  }
}

</script>
<style lang="scss">
.dropdown-custom .vs-dropdown--custom {
  margin-top: 10px;
}

.initial {
  .fa-circle {
    color: #ffea00 !important;
  }

  td {
    color: #555;
  }
}
.yangin {
  .fa-circle, svg {
    color: #a10000 !important;
  }

  td {
    color: #555;
  }
}
.yangin-degil {
  .fa-circle, svg {
    color: #555 !important;
  }

  td {
    color: #555;
  }

}
.yangin-kontrol {
  .fa-circle, svg {
    color: #c57400 !important;
  }

  td {
    color: #555;
  }
}
.sogutma {
  .fa-circle, svg {
    color: #2c8a02 !important;
  }

  td {
    color: #555;
  }
}
.yangin-sondu {
  color: #555 !important;
  svg {
    color: #555 !important;
  }

  td {
    color: unset;
  }
  .yangin-sondu-in svg {
    color:#555;
  }
}

.tooltip {
  display: block !important;
  z-index: 99000;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}
</style>
